export const claim = {
  emergencyStatus: [{
    value: 1,
    label: '理赔处理中'
  }, {
    value: 2,
    label: '理赔成功'
  }, {
    value: 3,
    label: '理赔失败'
  }]
}

export default {
  claim
}



// WEBPACK FOOTER //
// ./src/data/claim.js